//Add Quotes
export const ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO = "ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO"
export const ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_SUCCESS = "ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_SUCCESS"
export const ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_FAIL = "ADD_QUOTES_SEA_EXPORT_GENERAL_CARGO_FAIL"
//Get all qotes
export const GET_ALL_QUOTES = "GET_ALL_QUOTES"
export const GET_ALL_QUOTES_SUCCESS = "GET_ALL_QUOTES_SUCCESS"
export const GET_ALL_QUOTES_FAIL = "GET_ALL_QUOTES_FAIL"
// GEt by id quotes
export const GET_BY_ID_QUOTES = "GET_BY_ID_QUOTES"
export const GET_BY_ID_QUOTES_SUCCESS = "GET_BY_ID_QUOTES_SUCCESS"
export const GET_BY_ID_QUOTES_FAIL = "GET_BY_ID_QUOTES_FAIL"
// delete quote
export const DELETE_QUOTES = "DELETE_QUOTES"
export const DELETE_QUOTES_SUCCESS = "DELETE_QUOTES_SUCCESS"
export const DELETE_QUOTES_FAIL = "DELETE_QUOTES_FAIL"
export const DELETE_QUOTES_RESET = " DELETE_QUOTES_RESET"
// Quote status update
export const QUOTE_STATUS_UPDATE = "QUOTE_STATUS_UPDATE"
export const QUOTE_STATUS_UPDATE_SUCCESS = "QUOTE_STATUS_UPDATE_SUCCESS"
export const QUOTE_STATUS_UPDATE_FAIL = "QUOTE_STATUS_UPDATE_FAIL"
//add air shipment information
export const ADD_AIR_SHIPMENT_INFO = "ADD_AIR_SHIPMENT_INFO"
export const ADD_AIR_SHIPMENT_INFO_SUCCESS = "ADD_AIR_SHIPMENT_INFO_SUCCESS"
export const ADD_AIR_SHIPMENT_INFO_FAIL = "ADD_AIR_SHIPMENT_INFO_FAIL"
export const ADD_AIR_SHIPMENT_INFO_LOADER = "ADD_AIR_SHIPMENT_INFO_LOADER"
//get air shipment information by shipper-id
export const GET_AIR_SHIPPER_INFO_BY_ID = "GET_AIR_SHIPPER_INFO_BY_ID"
export const GET_AIR_SHIPPER_INFO_BY_ID_SUCCESS = "GET_AIR_SHIPPER_INFO_BY_ID_SUCCESS"
export const GET_AIR_SHIPPER_INFO_BY_ID_FAIL = "GET_AIR_SHIPPER_INFO_BY_ID_FAIL"
export const GET_AIR_SHIPPER_INFO_BY_ID_LOADER = "GET_AIR_SHIPPER_INFO_BY_ID_LOADER"
//add sea shipment information
export const ADD_SEA_SHIPMENT_INFO = "ADD_SEA_SHIPMENT_INFO"
export const ADD_SEA_SHIPMENT_INFO_SUCCESS = "ADD_SEA_SHIPMENT_INFO_SUCCESS"
export const ADD_SEA_SHIPMENT_INFO_FAIL = "ADD_SEA_SHIPMENT_INFO_FAIL"
export const ADD_SEA_SHIPMENT_INFO_LOADER = "ADD_SEA_SHIPMENT_INFO_LOADER"
//get sea shipment information by shipper-id
export const GET_SEA_SHIPPER_INFO_BY_ID = "GET_SEA_SHIPPER_INFO_BY_ID"
export const GET_SEA_SHIPPER_INFO_BY_ID_SUCCESS = "GET_SEA_SHIPPER_INFO_BY_ID_SUCCESS"
export const GET_SEA_SHIPPER_INFO_BY_ID_FAIL = "GET_SEA_SHIPPER_INFO_BY_ID_FAIL"
export const GET_SEA_SHIPPER_INFO_BY_ID_LOADER = "GET_SEA_SHIPPER_INFO_BY_ID_LOADER"
//air shipper info status update 
export const AIR_SHIPPER_INFO_STATUS_UPDATE = "AIR_SHIPPER_INFO_STATUS_UPDATE"
export const AIR_SHIPPER_INFO_STATUS_UPDATE_FAIL = "AIR_SHIPPER_INFO_STATUS_UPDATE_FAIL"
export const AIR_SHIPPER_INFO_STATUS_UPDATE_SUCCESS = "AIR_SHIPPER_INFO_STATUS_UPDATE_SUCCESS"
export const AIR_SHIPPER_INFO_STATUS_UPDATE_LOADER = "AIR_SHIPPER_INFO_STATUS_UPDATE_LOADER"
//sea shipper info status update 
export const SEA_SHIPPER_INFO_STATUS_UPDATE = "SEA_SHIPPER_INFO_STATUS_UPDATE"
export const SEA_SHIPPER_INFO_STATUS_UPDATE_FAIL = "SEA_SHIPPER_INFO_STATUS_UPDATE_FAIL"
export const SEA_SHIPPER_INFO_STATUS_UPDATE_SUCCESS = "SEA_SHIPPER_INFO_STATUS_UPDATE_SUCCESS"
export const SEA_SHIPPER_INFO_STATUS_UPDATE_LOADER = "SEA_SHIPPER_INFO_STATUS_UPDATE_LOADER"